export default {
  activeProjectId: null,
  activeProject: null,     // opcional: payload completo do getActive
  options: null,           // zoom, center etc
  status: 'idle',          // idle | loading | ready | error
  error: null
}
